const PROJECT_ARCHIVE_ROUTE = "/fnesl/v1/project-archive";

export function resolveProjectArchiveEndpoint(endpoint) {
  if (typeof endpoint === "string" && endpoint.trim()) return endpoint;

  // Cached markup from before the endpoint setting was added must still work.
  // WordPress advertises the REST root even for subdirectory installations and
  // sites using ?rest_route= instead of pretty permalinks.
  const restRoot = globalThis.document
    ?.querySelector('link[rel="https://api.w.org/"]')?.href
    || globalThis.wpApiSettings?.root;

  if (!restRoot) {
    throw new Error("The projects API address is unavailable. Please reload the page.");
  }

  const url = new URL(restRoot, globalThis.location?.href);
  if (url.searchParams.has("rest_route")) {
    const route = url.searchParams.get("rest_route").replace(/\/$/, "");
    url.searchParams.set("rest_route", route + PROJECT_ARCHIVE_ROUTE);
  } else {
    url.pathname = url.pathname.replace(/\/$/, "") + PROJECT_ARCHIVE_ROUTE;
  }
  return url.href;
}

export async function fetchProjectArchive({
  endpoint,
  page = 1,
  perPage = 12,
  mode = "and",
  terms = {},
  show = [],
  includeFilters = false,
} = {}) {
  // This endpoint only returns published projects. Do not send cached REST
  // nonces or login cookies through the editor's global apiFetch middleware.
  const response = await fetch(resolveProjectArchiveEndpoint(endpoint), {
    method: "POST",
    credentials: "omit",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ page, perPage, mode, terms, show, includeFilters }),
  });
  let data;
  try {
    data = await response.json();
  } catch {
    throw new Error("The projects service returned an invalid response. Please try again later.");
  }
  if (!response.ok) {
    throw new Error(data?.message || "Unable to load projects. Please try again.");
  }
  return data;
}
